import React from 'react';
import { TextView } from '@atoms';
import { Box } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
const FAQList = ({
  data: { question, answer },
  onDelete,
  onEdit
}: {
  data: CoreKnowledgeBase;
  onDelete: () => void;
  onEdit: () => void;
}) => {
  const [showMore, setShowMore] = React.useState(false);

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        mt: '0.5rem'
      }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'center',
          mb: 2,
          p: '1rem',
          border: '1px solid #ccc',
          borderRadius: '8px',
          gap: '1rem',
          width: '100%'
        }}>
        <div>
          <TextView $fontSize={16} sx={{ mb: 2 }}>
            <strong>Q: </strong> {question}
          </TextView>
          <TextView
            $fontSize={16}
            sx={{
              mb: 2
            }}>
            <strong>A: </strong>
            {showMore ? answer : `${answer.substring(0, 350)}...`}
            <span
              onClick={() => setShowMore(!showMore)}
              style={{ color: 'blue', cursor: 'pointer' }}>
              {showMore ? ' Show Less' : ' Show More'}
            </span>
          </TextView>
        </div>
        <div>
          <DeleteIcon
            onClick={onDelete}
            sx={{
              cursor: 'pointer',
              color: 'red',
              border: '1px solid #ccc',
              padding: '0.5rem',
              borderRadius: '8px'
            }}
          />
          <EditIcon
            onClick={onEdit}
            sx={{
              cursor: 'pointer',
              color: 'blue',
              border: '1px solid #ccc',
              padding: '0.5rem',
              borderRadius: '8px'
            }}
          />
        </div>
      </Box>
    </Box>
  );
};

export default FAQList;
